export enum MasterCardSaveOption {
  ADD,
  ADD_AND_DELETE,
  REPLACE_MEDIA,
  EDIT_ONLY_IN_MASTER_CARD
}
